import defaultTheme from "tailwindcss/defaultTheme";

/** @type {import('tailwindcss').Config} */
export default {
  content: ["./src/**/*.{astro,html,js,jsx,md,mdx,svelte,ts,tsx,vue}"],
  theme: {
    /*
    fontSize: {
      base: ["1.25rem", "1.5rem"], // Default font size Bodytext desktop
    },
    */
    extend: {
      fontFamily: {
        sans: ["aktiv-grotesk", ...defaultTheme.fontFamily.sans],
      },
      fontWeight: {
        light: 300,
        normal: 400,
        medium: 500,
        bold: 700,
      },
      fontSize: {
        "intro-mobile-smallest": ["1.6rem", "120%"],
        "headline-mobile-smallest": ["1.55rem", "123%"],
        //
        "intro-desktop-smaller": ["2.8rem", "120%"],
        "headline-desktop-smaller": ["2.5rem", "120%"],
        "intro-desktop": ["3.75rem", "120%"], // Großer Introtext desktop 60px / 16px = 3.75rem
        "headline-desktop": ["3.125rem", "120%"], // Headline desktop         50px / 16px = 3.125rem
        "lead-desktop": ["1.875rem", "120%"], // Leadtext desktop         30px / 16px = 1.875rem
        "subheadline-desktop": ["1.5625rem", "120%"], // Subheadline desktop   25px / 16px = 1.5625rem
        "body-desktop": ["1.25rem", "120%"], // Bodytext desktop         20px / 16px = 1.25rem
        "intro-mobile": ["1.75rem", "120%"], // Großer Introtext mobile  28px / 16px = 1.75rem
        "headline-mobile": ["1.75rem", "123%"], // Headline mobile          28px / 16px = 1.75rem
        "lead-mobile": ["1.25rem", "120%"], // Leadtext mobile          20px / 16px = 1.25rem
        "subheadline-mobile": ["1.1875rem", "120%"], // Subheadline mobile    19px / 16px = 1.1875rem
        "body-mobile": ["1rem", "122%"], // Bodytext mobile          16px / 16px = 1rem
        "menu-mobile": ["1.125rem", "120%"], // Menu mobile          18px / 16px = 1.125rem
        "menu-second-mobile": ["0.875rem", "100%"], // Menu mobile          14px / 16px = 0.875rem
      },
      scale: {
        120: "1.2",
        250: "2.5",
      },
      translate: {
        100: "100%",
      },
      screens: {
        xspro: "390px",
        xsprom: "428px",
        //
        "3xl": "1728px",
        "4xl": "1800px",
        "5xl": "1920px",
        "6xl": "2120px",
        "7xl": "2560px",
        content: "1336px",
        // "content-wider": "1483px", // Still relevant?
        "content-wide": "1608px", // 1728px - 2x 60 Padding
      },
      colors: {
        bfuture: {
          yellow: "#FFF000",
          pink: "#F170E4",
          red: "#E94D43",
          green: "#69DB2D",
          blue: "#3B8BEE",
          gray: "#F4F5F4",
        },
        "page-primary": "var(--page-primary-color)",
      },
    },
  },
  variants: {
    extend: {
      scale: ["responsive"],
      translate: ["responsive"],
    },
  },
  plugins: [],
};
